import React from 'react';
import { Empty, ErrorText, Panel, useChrome } from './ceoChrome';

function when(iso) {
  if (!iso) return '';
  const date = new Date(iso);
  if (!Number.isFinite(date.getTime())) return '';
  return date.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
}

function Row({ chrome, title, value, href, detail }) {
  return (
    <Panel chrome={chrome} title={title}>
      <div style={{ color: chrome.secondary, fontSize: 13 }}>{title}</div>
      <div style={{ fontSize: 22, fontWeight: 600, marginTop: 6 }}>{value}</div>
      {detail ? <div style={{ color: chrome.secondary, marginTop: 6 }}>{detail}</div> : null}
      {href ? <a href={href} style={{ color: '#1d1d1f', display: 'inline-flex', minHeight: 44, alignItems: 'center' }}>Open</a> : null}
    </Panel>
  );
}

export default function SystemHealthPanel({ colors, narrow, data, error }) {
  const chrome = useChrome(colors, narrow);
  const netlify = (data && data.netlify) || { label: 'Not connected', href: 'https://app.netlify.com' };
  const jobs = data && data.jobs;
  const errors = data && data.errors;
  const xcode = (data && data.xcode) || { label: 'Not connected' };
  return (
    <div style={chrome.page} data-testid="ceo-system">
      <div>
        <h2 style={chrome.title}>System health</h2>
        <p style={chrome.sub}>Deploys, scheduled jobs, error spikes, and Xcode Cloud. A missing connection stays blank.</p>
      </div>
      {error ? <ErrorText>{error}</ErrorText> : null}
      {!data && !error ? <Empty chrome={chrome}>Loading…</Empty> : null}
      {data ? (
        <>
          <Row chrome={chrome} title="Netlify" value={netlify.label || 'Not connected'} href={netlify.href} detail={[netlify.context, netlify.branch, when(netlify.publishedAt)].filter(Boolean).join(' · ')} />
          <Panel chrome={chrome} title="Scheduled jobs">
            <div style={{ fontSize: 17, fontWeight: 600 }}>{jobs && jobs.connected === false ? 'Not connected' : 'Scheduled jobs'}</div>
            {jobs && jobs.connected && (jobs.runs || []).length === 0 ? <Empty chrome={chrome}>No job runs yet.</Empty> : null}
            {jobs && jobs.connected ? (jobs.runs || []).map((run) => (
              <div key={run.jobName} style={{ display: 'flex', justifyContent: 'space-between', gap: 12, minHeight: 44, alignItems: 'center', borderTop: `1px solid ${chrome.line}` }}>
                <span>{run.jobName}</span>
                <span>{run.status}</span>
              </div>
            )) : null}
          </Panel>
          <Row
            chrome={chrome}
            title="Client errors"
            value={errors && errors.connected === false ? 'Not connected' : (errors && errors.spike ? 'Spike' : 'Steady')}
            detail={errors && errors.connected !== false ? `${errors.recent} in 24 hours · ${errors.previous} in the previous day` : ''}
          />
          <Row chrome={chrome} title="Xcode Cloud" value={xcode.label || 'Not connected'} href={xcode.href} detail={xcode.name || ''} />
        </>
      ) : null}
    </div>
  );
}
